import { TableRow, TableCell } from '@sanlam-glacier/app-common/components';
import styles from '../../../../pages/intermediary/intermediary.module.scss';

export type Transaction = {
  id: number;
  date: Date;
  transactionType: string;
  description: string;
  transactionAmount: string;
  cumulativeTotal: string;
};

type ReportTableProps = {
  row: Transaction;
};

export const TransactionsTableRow = ({ row }: ReportTableProps) => {
  return (
    <TableRow key={row.id}>
      <TableCell data-testid={`transactionDate-${row.id}`} align={TableCell.ALIGN.LEFT}>
        {row.date.toDateString()}
      </TableCell>
      <TableCell
        data-testid={`transactionType-${row.id}`}
        align={TableCell.ALIGN.LEFT}
        className={styles.hideTransactionType}
      >
        {row.transactionType}
      </TableCell>
      <TableCell
        data-testid={`transactionDescription-${row.id}`}
        align={TableCell.ALIGN.LEFT}
        className={styles.truncatedCell}
      >
        {row.description}
      </TableCell>
      <TableCell data-testid={`transactionAmount-${row.id}`} align={TableCell.ALIGN.RIGHT}>
        {row.transactionAmount}
      </TableCell>
      <TableCell
        data-testid={`transactionCumulativeTotal-${row.id}`}
        padding={TableCell.PADDING.CHECKBOX}
        align={TableCell.ALIGN.RIGHT}
      >
        {row.cumulativeTotal}
      </TableCell>
    </TableRow>
  );
};
